export default __webpack_public_path__ + "static/media/starimg_green.825d5c1f.svg";